import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { navigation } from '../data/mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 px-4 py-4 md:px-6">
      <nav 
        className="max-w-6xl mx-auto flex items-center justify-between px-4 md:px-6 h-14 bg-white/60 backdrop-blur-xl border border-black/10 rounded-full shadow-sm"
      >
        {/* Logo */}
        <a 
          href="/" 
          className="text-lg font-bold tracking-tight"
          style={{ color: 'var(--text-primary)' }}
        >
          {navigation.brand}
        </a>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-1">
          {navigation.links.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="nav-link"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* CTA Button */}
        <div className="hidden md:block">
          <a
            href={navigation.ctaUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary text-sm px-5 py-2.5 min-h-0"
          >
            {navigation.ctaText}
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 rounded-full hover:bg-black/5 transition-colors"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden mt-2 mx-4 p-4 bg-white/95 backdrop-blur-xl border border-black/10 rounded-2xl shadow-lg">
          <div className="flex flex-col gap-2">
            {navigation.links.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="nav-link py-3 px-4"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a
              href={navigation.ctaUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary mt-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              {navigation.ctaText}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
